import { render, staticRenderFns } from "./ServiceJob.vue?vue&type=template&id=24694ffb&scoped=true"
import script from "./ServiceJob.vue?vue&type=script&lang=js"
export * from "./ServiceJob.vue?vue&type=script&lang=js"
import style0 from "./ServiceJob.vue?vue&type=style&index=0&id=24694ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24694ffb",
  null
  
)

export default component.exports